import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
import Statics from "../components/statics";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: "50vh",
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 100,
    },
  },
  next: {
    y: "-100vh",
    transition: { ease: "easeInOut", duration: 0.8 },
  },
  back: {
    y: "+100vh",
    transition: { ease: "easeInOut", duration: 0.8 },
  },
};

const titleVariants = {
  hidden: {
    opacity: 0,
    y: "-200px",
  },
  show: {
    opacity: 1,
    y: "0px",
    transition: {
      duration: 3,
      ease: "easeInOut",
    },
  },
};

const Slide3 = ({ screen }) => {
  const [exit, setExit] = useState("next");
  return (
    <motion.div
      className="about-container"
      variants={containerVariants}
      initial="hidden"
      animate="show"
      exit={exit}
    >
      <motion.div
        style={{
          position: "absolute",
          fontSize: "2rem",
          fontFamily: "Champagne",
          width: "100%",
          textAlign: "center",
        }}
        variants={titleVariants}
        initial="hidden"
        animate="show"
      >
        Lo que Diana <span style={{ color: "red" }}>NO</span> sabe
      </motion.div>

      <div
        style={{
          height: "100vh",
          width: "80%",
          margin: "auto",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} style={{ padding: 0 }}>
            <div style={{ textAlign: screen > 600 ? "left" : "center" }}>
              <motion.h1
                initial={{ y: 10 }}
                animate={{
                  y: -10,
                  transition: {
                    duration: 1,
                    ease: "easeIn",
                    repeat: Infinity,
                    repeatType: "reverse",
                  },
                }}
                onClick={() => {
                  setExit("back");
                }}
              >
                <Link className="link" to="/slide2">
                  &#8657;
                </Link>
              </motion.h1>
            </div>

            <div
              style={{
                display: screen > 600 ? "grid" : "inline-block",
                alignItems: "center",
                minHeight: "70vh",
              }}
              data-aos="fade-up"
              data-aos-offset="500"
            >
              <div
                style={{
                  color: "white",
                  fontSize: screen > 600 ? "3.5rem" : "2rem",
                  lineHeight: screen > 600 ? "2.5rem" : "2rem",
                  fontFamily: "Champagne",
                  textAlign: screen > 600 ? "left" : "center",
                }}
              >
                Es que, al finalizar de pagar el crédito, habrá pagado hasta
                <span style={{ color: "red" }}> 3 veces</span> el valor original
                de su deuda
              </div>
            </div>
            <div
              style={{
                textAlign: screen > 600 ? "left" : "center",
                zIndex: 200,
              }}
            >
              <motion.h1
                initial={{ y: -10 }}
                animate={{
                  y: 10,
                  transition: {
                    duration: 1,
                    ease: "easeIn",
                    repeat: Infinity,
                    repeatType: "reverse",
                  },
                }}
                onClick={() => {
                  setExit("next");
                }}
              >
                <Link className="link" to="/slide4">
                  &#8659;
                </Link>
              </motion.h1>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ padding: 0, zIndex: screen > 600 ? 2 : -1 }}
          >
            <Statics screen={screen} />
          </Grid>
        </Grid>
      </div>
    </motion.div>
  );
};

export default Slide3;
